import {
  getLoanGeneralReportXLS
} from "../../../helpers/fakebackend_helper";

import moment from "moment";
import { ToastContainer } from 'react-toastify';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useLoader } from "../../../context/LoaderContext";

const LoanReport = () => {
  const { showLoader, hideLoader } = useLoader();


  const handleDownloadLoanPaymentList = async () => {
    showLoader();

    try {
      const params = {
      }
      const response = await getLoanGeneralReportXLS(params);
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Cartera de Creditos al ' + moment().format('YYYY-MM-DD') + '.xlsx';
      a.click();
    } catch (error) {
      toast.error("Error downloading loan payment list: " + error, { autoClose: 2000 });
    } finally {
      hideLoader();
    }
  };


  return (
    <div className="card">
      <ToastContainer closeButton={false} limit={1} />

      <div className="card-body">

        <div className="grid grid-cols-1 gap-4 mb-5 lg:grid-cols-2 xl:grid-cols-12">

          <div className="xl:col-span-3">
            <button
              onClick={handleDownloadLoanPaymentList}
              className="flex items-center gap-2 px-4 py-2 bg-green-500 hover:bg-green-600 text-white text-sm font-semibold rounded-lg shadow-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-green-300"
            >
              <i className="ri-file-excel-2-line text-lg"></i>
              Descargar Cartera de Creditos
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default LoanReport;
